import { Component, OnInit, HostListener, inject } from '@angular/core';
import {
  UntypedFormControl,
  Validators,
  UntypedFormGroup,
} from '@angular/forms';
import * as uuid from 'uuid';
import { StartupModel } from '../classes/model';
import { RdsServerService } from '../services/rds-server.service';
import { ImageUploadService } from '../services/image-upload.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ar-vr-form',
  templateUrl: './ar-vr-form.component.html',
  styleUrls: ['./ar-vr-form.component.scss'],
  host: {
    class: 'form',
  },
})
export class ArVrFormComponent implements OnInit {
  progressSpinner = false;
  showOptions = false;

  constructor(
    private _rdsServer: RdsServerService,
    private imageUploadService: ImageUploadService,
    private snackbar: MatSnackBar
  ) { }

  industries = [];

  ngOnInit(): void {
    // document.title = 'AR VR Challenge'

    document.getElementById('one').classList.add('active');
    document.getElementById('two').classList.add('inactive');

    this._rdsServer.getIndustryList().subscribe(res => {
      for (const e in res) {
        this.industries.push(res[e])
      }
    })

       this._rdsServer.getAllSectorList().subscribe(res => {
      const uniqueSectors = [];
      const others = [];
    
      for (const e in res) {
        const newText = res[e]['text'];
        if (!uniqueSectors.some(sector => sector.text === newText)) {
          uniqueSectors.push(res[e]);
        }
      }
    
      // Sort uniqueSectors by text
      uniqueSectors.sort((a, b) => {
        if (a.text === "Others") return 1; // "Others" should come last
        if (b.text === "Others") return -1; // "Others" should come last
        return a.text.localeCompare(b.text); // Sort alphabetically for other values
      });
    
      // Append "Others" to the end if it exists
      const othersIndex = uniqueSectors.findIndex(sector => sector.text === "Others");
      if (othersIndex !== -1) {
        others.push(uniqueSectors[othersIndex]);
        uniqueSectors.splice(othersIndex, 1);
      }
    
      // Concatenate uniqueSectors and others
      this.sectors = [...uniqueSectors, ...others];
    });


    this._rdsServer.getStateList().subscribe((res) => {
      for (const e in res) {
        this.states.push(res[e]);
      }
    });
  }


  getSectorsList() {

    this.sectors = []

    var value = this.startupData.get('sIndustry').value;

    for (const e in this.industries) {
      if (this.industries[e]['text'] == value) {
        this._rdsServer.getSectorList(this.industries[e]['id']).subscribe(res => {
          for (const e in res)
            this.sectors.push(res[e])
        })
      }
    }
  }



  /* FORM GROUP */
  startupData = new UntypedFormGroup({
    sName: new UntypedFormControl('', Validators.required),
    sBrief: new UntypedFormControl('', Validators.required),
    sEmail: new UntypedFormControl('', [Validators.required, Validators.email]),
    sSector: new UntypedFormControl(null, Validators.required),
    sMobile: new UntypedFormControl('', Validators.required),
    sIndustry: new UntypedFormControl(null, Validators.required),
    sState: new UntypedFormControl(null, Validators.required),
    sCity: new UntypedFormControl(null, Validators.required),
    sInterest: new UntypedFormGroup({
      all: new UntypedFormControl(false),
      mentoring: new UntypedFormControl(false),
      incubation: new UntypedFormControl(false),
      acceleration: new UntypedFormControl(false),
      investment: new UntypedFormControl(false),
    }),
    fundOrBoot: new UntypedFormControl(true),
    sWebsite: new UntypedFormControl(''),
    sAppLink: new UntypedFormControl('', Validators.required),
    stage: new UntypedFormControl('', Validators.required),
    test: new UntypedFormControl(''),
    sFname: new UntypedFormControl('', Validators.required),
    sLname: new UntypedFormControl('', Validators.required),
  });


  firstCap(str) {
    return (str[0].toUpperCase() + str.substring(1, str.length));
  }

  // Logo Upload
  logoBlob;
  logoExtension;
  logoKeyName;
  logoBase64: any = '../../assets/upload2.svg';
  // Pitch Deck Upload
  pitchBlob;
  pitchExtension;
  pitchKeyName;
  pitchBase64: any = '../../assets/upload2.svg';
  // '../../assets/1x/Asset 3.png'
  pitchChanged = false;
  // Arrays for drop downs
  cities = [];
  states = [];
  // variable to track page number
  activeSection = 1;

  sectors = [
    // 'Environmental Conservation',
    // 'Affordable Heathcare',
    // 'Sustainable Rural Economy',
    // 'Technologies for Better Governance',
    // 'Economic Growth of SMEs',
    // 'Gender Diversity & Inclusion',
  ];

  checkAvailableOptions(type, err) { }

  stateSelected() {
    this.cities = [];
    var value = this.startupData.get('sState').value;

    for (const e in this.states) {
      if (this.states[e]['text'] == value) {
        this._rdsServer.getCityList(this.states[e]['id']).subscribe((res) => {
          for (const e in res) this.cities.push(res[e]);
        });
      }
    }
  }
  // ======================= functions to change section ================================
  next() {
    if (this.activeSection == 1) {
      document.getElementById('two').classList.replace('inactive', 'active');

      document.getElementById('dot-con').style.backgroundColor = 'white';
      setTimeout(() => {
        document.getElementById('dot-con').style.backgroundColor =
          'transparent';
        document.getElementById('one').classList.replace('active', 'inactive');
      }, 500);
    }
    if (this.activeSection == 2) {
      return 0;
    }
    this.activeSection += 1;
  }

  previous() {
    if (this.activeSection == 2) {
      document.getElementById('one').classList.replace('inactive', 'active');

      document.getElementById('dot-con').style.backgroundColor = 'white';
      setTimeout(() => {
        document.getElementById('dot-con').style.backgroundColor =
          'transparent';
        document.getElementById('two').classList.replace('active', 'inactive');
      }, 500);
    }
    if (this.activeSection == 1) {
      return 0;
    }
    this.activeSection -= 1;
  }
  // ======================= functions to change section ================================

  /* function to upload pitch deck */
  pitchUpload(file) {
    let non_pdf = document.getElementById('non-uploaded').offsetWidth;

    if (file[0].size > 5242880) {
      // alert("File is too big! Max size allowed is 5MB");
      this.snackbar.open('File is too big! Max size allowed is 5MB.', 'OK');
      return 0;
    }

    this.pitchBlob = file[0];
    this.pitchExtension = this.pitchBlob.name.split('.').pop();
    let allowedExt = ['pdf', 'pptx', 'ppt'];
    if (!allowedExt.includes(this.pitchExtension)) {
      // this.snackbar.open("Please upload a .pdf,.pptx,.ppt file only.", "OK");
      this.pitchBase64 = '../../assets/upload/Error_upload.svg';
      return;
    }

    this.pitchKeyName = uuid.v4() + '.' + this.pitchExtension;
    this.pitchChanged = true;
    if (this.pitchExtension == 'pdf')
      this.pitchBase64 = '../../assets/pdfIco.png';
    else this.pitchBase64 = '../../assets/docx.png';
    setTimeout(() => {
      document.getElementById('pdf').style.margin = `6px ${(non_pdf - 50) / 2
        }px`;
    }, 50);
  }

  /* function to upload logo */
  uploadLogo(file) {
    if (file[0].size > 2097152) {
      this.snackbar.open('File is too big! Max size allowed is 2MB.', 'OK');
      return 0;
    }

    this.logoBlob = file[0];
    const reader = new FileReader();
    reader.readAsDataURL(file[0]);
    reader.onloadend = (_event) => {
      this.logoBase64 = reader.result;
    };
    this.logoExtension = this.logoBlob.name.split('.').pop();
    this.logoKeyName = uuid.v4() + '.' + this.logoExtension;
  }

  // function for checkboxes
  checkAll() {
    if (this.startupData.get('sInterest').value['all'] == false) {
      if (!this.startupData.get('sInterest').value['mentoring'])
        this.startupData.controls.sInterest['controls'].mentoring.patchValue(
          true
        );
      if (!this.startupData.get('sInterest').value['incubation'])
        this.startupData.controls.sInterest['controls'].incubation.patchValue(
          true
        );
      if (!this.startupData.get('sInterest').value['acceleration'])
        this.startupData.controls.sInterest['controls'].acceleration.patchValue(
          true
        );
      if (!this.startupData.get('sInterest').value['investment'])
        this.startupData.controls.sInterest['controls'].investment.patchValue(
          true
        );
    }

    if (this.startupData.get('sInterest').value['all'] == true) {
      if (this.startupData.get('sInterest').value['mentoring'])
        this.startupData.controls.sInterest['controls'].mentoring.patchValue(
          false
        );
      if (this.startupData.get('sInterest').value['incubation'])
        this.startupData.controls.sInterest['controls'].incubation.patchValue(
          false
        );
      if (this.startupData.get('sInterest').value['acceleration'])
        this.startupData.controls.sInterest['controls'].acceleration.patchValue(
          false
        );
      if (this.startupData.get('sInterest').value['investment'])
        this.startupData.controls.sInterest['controls'].investment.patchValue(
          false
        );
    }
  }
  // function for checkboxes
  processAll(type) {
    if (type == 2 && !this.startupData.get('sInterest').value['mentoring']) {
      this.startupData.controls.sInterest['controls'].all.patchValue(false);
    }
    if (type == 3 && !this.startupData.get('sInterest').value['incubation']) {
      this.startupData.controls.sInterest['controls'].all.patchValue(false);
    }
    if (type == 4 && !this.startupData.get('sInterest').value['acceleration']) {
      this.startupData.controls.sInterest['controls'].all.patchValue(false);
    }
    if (type == 5 && !this.startupData.get('sInterest').value['investment']) {
      this.startupData.controls.sInterest['controls'].all.patchValue(false);
    }
    if (this.checkIfAllAreTrue()) {
      this.startupData.controls.sInterest['controls'].all.patchValue(true);
    }
  }
  // function for checkboxes
  checkIfAllAreTrue() {
    return (
      this.startupData.get('sInterest').value['mentoring'] &&
      this.startupData.get('sInterest').value['incubation'] &&
      this.startupData.get('sInterest').value['acceleration'] &&
      this.startupData.get('sInterest').value['investment']
    );
  }

  startupStorage = new StartupModel();

  checkFileUploads() {
    if (this.pitchKeyName == undefined || this.pitchKeyName == null) {
      return false;
    }
    return true;
  }

  stageWarn = false;
  interestWarn = false;
  briefWarn = false;

  /* SUBMIT FORM FUNCTION */
  submit() {
    this.progressSpinner = true;
    console.log(this.startupData)
    if (!this.startupData.valid) {
      document.getElementById('snack').classList.add('appear');
      this.message = 'Please Enter All Required Details !';

      this.stageWarn = true;
      this.interestWarn = true;
      this.briefWarn = true;

      setTimeout(() => {
        document.getElementById('snack').classList.remove('appear');
      }, 500);
      this.progressSpinner = false;
      return 0;
    } else if (!this.checkFileUploads()) {
      document.getElementById('snack').classList.add('appear');
      this.message = 'Upload Pitch Deck First !';
      setTimeout(() => {
        document.getElementById('snack').classList.remove('appear');
      }, 500);
      this.progressSpinner = false;
      return 0;
    }

    console.log(this.startupData.value);

    this.startupStorage.id = uuid.v4();

    this.startupStorage.name = this.startupData.value.sName;
    this.startupStorage.industry = this.startupData.value.sIndustry;
    this.startupStorage.sector = this.startupData.value.sSector;
    if (this.startupData.value.fundOrBoot) {
      var fB = 'bootstrap';
    } else if (!this.startupData.value.fundOrBoot) {
      var fB = 'funded';
    }

    this.startupStorage.fundedOrBoot = fB;
    this.startupStorage.stage = this.startupData.value.stage;
    this.startupStorage.interests = JSON.stringify(
      this.startupData.value.sInterest
    );
    this.startupStorage.description = this.startupData.value.sBrief;
    //
    this.startupStorage.pitch = this.pitchKeyName;
    this.startupStorage.logo = this.logoKeyName;
    //
    this.startupStorage.state = this.startupData.value.sState;
    this.startupStorage.city = this.startupData.value.sCity;
    this.startupStorage.email = this.startupData.value.sEmail;
    this.startupStorage.mobile = this.startupData.value.sMobile;
    this.startupStorage.website = this.startupData.value.sWebsite;
    this.startupStorage.mobileApp = this.startupData.value.sAppLink;
    //
    this.startupStorage.webSource = 'Startup Jaipur';
    this.startupStorage.status = 'Response Awaited';
    //
    this.startupStorage.StartupApply_FirstName = this.startupData.value.sFname;
    this.startupStorage.StartupApply_LastName = this.startupData.value.sLname;

    this._rdsServer
      .getStartupLogoImageUrl(this.logoKeyName, this.logoExtension)
      .subscribe((resLogo) => {
        console.log(resLogo);
        this._rdsServer
          .getStartupPitchImageUrl(this.pitchKeyName, this.pitchExtension)
          .subscribe((resPitch) => {
            console.log(resPitch);
            this.imageUploadService
              .uploadImage(
                resLogo['ImageUrl'],
                this.logoExtension,
                this.logoBlob
              )
              .subscribe((resLogoUplad) => {
                console.log(resLogoUplad);
                this.imageUploadService
                  .uploadImage(
                    resPitch['ImageUrl'],
                    this.pitchExtension,
                    this.pitchBlob
                  )
                  .subscribe((resPitchUpload) => {
                    console.log(resPitchUpload);
                    this._rdsServer
                      .postStartupForm(this.startupStorage)
                      .subscribe((res) => {
                        console.log(res);
                        document
                          .getElementById('snack')
                          .classList.add('appear-slide');
                        this.progressSpinner = false;
                        this.message = 'Form Submitted Successfully !';
                      });
                  });
              });
          });
      });
  }



  message = '';
  textCount = 0;

  changeCharCount(str) {
    this.textCount = str.length;
  }

  changeType(str) {
    var fund = document.getElementById('fund');
    var boot = document.getElementById('boot');
    var active = document.getElementById('active');
    if (str == 'funded') {
      boot.style.color = 'black';
      fund.style.color = 'white';
      active.style.right = '122px';
      this.startupData.patchValue({ fundOrBoot: true });
    } else if (str == 'bootstrap') {
      boot.style.color = 'white';
      fund.style.color = 'black';
      active.style.right = '2px';
      this.startupData.patchValue({ fundOrBoot: false });
    }
    console.log(this.startupData.value.fundOrBoot);
  }

  mouseEnter(id) {
    document.getElementById(id).style.opacity = '1';
    document.getElementById(id).style.display = 'block';
  }
  mouseLeave(id) {
    document.getElementById(id).style.opacity = '0';
    document.getElementById(id).style.display = 'none';
  }

  show() {
    this.showOptions = !this.showOptions;
  }

  pitchInputClick() {
    console.log('re')
    this.snackbar.open('Please add the revenue slide in the pitch deck', 'OK', {
      // duration: 10000,
      panelClass: ['custom-snackbar']
    }).afterDismissed().subscribe(res => {
      if (res.dismissedByAction)
        document.getElementById('pitchinput').click()
    })
    // this.snackbar.openFromComponent(PitchDeckComponent,{
    //   // duration: 10000,
    //   // panelClass: ['custom-snackbar']
    // }).afterDismissed().subscribe(res=>{
    //   if(res.dismissedByAction)
    //   document.getElementById('pitchinput').click()
    // })
  }

}


@Component({
  selector: 'snack-bar-annotated-component-example-snack',
  templateUrl: 'pitch-deck.component.html',
  styles: [
    `
    :host {
      display: flex;
    }

    .example-pizza-party {
      color: hotpink;
    }
  `,
  ],
  standalone: true,
  imports: [MatButtonModule, MatSnackBarModule],
})
export class PitchDeckComponent {
  snackBarRef = inject(MatSnackBarRef);
}
